module.exports = "pegasus_template/assets/blue-ghost-linkedin.png";